module.exports = __webpack_public_path__ + "img/Gallery_2_20.7255c916.jpeg";